import { toast } from "react-toastify"; 
export const handleShare = async ({
  title = "PraSha Sync",
  text = "Your Personalized Mental Healthcare Companion",
  url = "https://care.prashasync.io",
  imageUrl,       // optional logo/image
  channel = "system" // 👈 "system" | "whatsapp" | "gmail" | "instagram" | ...
} = {}) => {
  try {
    let files = [];

    // 🖼️ If imageUrl is provided, prepare it for navigator.share()
    if (imageUrl) {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const file = new File([blob], "share-image.png", { type: blob.type });
      files = [file];
    }

    const encodedText = encodeURIComponent(`${title} - ${text}`);
    const encodedUrl = encodeURIComponent(url);

    // 🌐 Predefined channel URLs
    const shareLinks = {
  whatsapp: `https://wa.me/?text=${encodedText}%0A${encodedUrl}`,
  gmail: `mailto:?subject=${encodeURIComponent(title)}&body=${encodedText}%0A${encodedUrl}`,
  yahoo: `https://compose.mail.yahoo.com/?subject=${encodeURIComponent(title)}&body=${encodedText}%0A${encodedUrl}`,
  outlook: `https://outlook.live.com/mail/0/deeplink/compose?subject=${encodeURIComponent(title)}&body=${encodedText}%0A${encodedUrl}`,
  instagram: `https://www.instagram.com/?url=${encodedUrl}`,
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
  linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
  twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
  telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
  pinterest: `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodeURIComponent(imageUrl || '')}&description=${encodedText}`,
  reddit: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodeURIComponent(title)}`,
  tumblr: `https://www.tumblr.com/widgets/share/tool?canonicalUrl=${encodedUrl}&title=${encodeURIComponent(title)}&caption=${encodedText}`,
  skype: `https://web.skype.com/share?url=${encodedUrl}&text=${encodedText}`,
  snapchat: `https://www.snapchat.com/scan?attachmentUrl=${encodedUrl}`,
  threads: `https://www.threads.net/intent/post?text=${encodedText}%20${encodedUrl}`,
};

     // 🆕 Copy URL option
    
    if (channel === "copy") {
    navigator.clipboard.writeText(url)
      .then(() => {
        toast.success("Link copied to clipboard!"); // feedback (optional)
      })
      .catch(() => {
        toast.error("Failed to copy link");
      });
    return;
  }

    if (channel === "system") {
      // ✅ Try native Web Share API with image support
      if (navigator.canShare && navigator.canShare({ files }) && files.length > 0) {
        await navigator.share({ title, text, url, files });
        return;
      }

      // ✅ Web Share without files
      if (navigator.share) {
        await navigator.share({ title, text, url });
        return;
      }

      // ⚠️ fallback to WhatsApp if system share not supported
      window.open(shareLinks.whatsapp, "_blank");
      return;
    }

    // ✅ Otherwise, open the requested social channel
    if (shareLinks[channel]) {
      window.open(shareLinks[channel], "_blank");
    } else {
      console.warn(`Unknown share channel: ${channel}`);
    }
  } catch (error) {
    console.error("Error sharing:", error);
  }
};
